import { render } from "./Index.vue?vue&type=template&id=52e8eb53&scoped=true&lang=html"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=52e8eb53&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52e8eb53"

export default script